import { useTikTokAdvertiserSummaryData } from '@anytag/shared-organisms';
import { TikTokBudgetAllocation } from '../../../pages/tiktok-advertiser-pages';

export const BudgetAllocation = () => {
  const { summaryData, loading } = useTikTokAdvertiserSummaryData();

  return <TikTokBudgetAllocation summaryData={summaryData} loading={loading} />;
};
